<template>
	<div
		class="box pa-20 min-height-350 overflow-y-auto mb-30"
	>
		<div :inner-html.prop="auth_info | nl2br"></div>
	</div>
</template>

<script>
	export default {
		name: 'AuthGuide'
		, props: ['user', 'shop_info']
		, data: function(){
			return {
				program: {
					name: '이용약관'
					, not_top: this.$common.isMobile()
					, title: true
					, bottom: true
					, from: 'Index'
					, top_line: true
				}
			}
		}
		, computed: {
			auth_info: function(){
				let t = ''
				if(this.$route.params.type == 'terms'){
					t = this.shop_info.site_terms
				}else if(this.$route.params.type == 'personal'){
					t = this.shop_info.site_personal
				}else if(this.$route.params.type == 'info'){
					t = this.shop_info.site_info
				}
				return t
			}
			, title: function(){
				let t = ''
				if(this.$route.params.type == 'terms'){
					t = '이용 약관'
				}else if(this.$route.params.type == 'personal'){
					t = '개인정보 처리방침'
				}else if(this.$route.params.type == 'info'){
					t = '이용안내'
				}
				return t
			}
		}
		, created() {

			this.program.name = this.title
			this.$bus.$emit('onLoad', this.program)
		}
	}
</script>